import React, { forwardRef } from 'react';

import { TextField } from '@material-ui/core';

import ControllerInput from './ControllerInput';

function getZeros(count) {
  let zeros = '';
  for (let i = 0; i < count; i++) zeros += '0';
  return zeros;
}

function formatNumberMask(value, decimalPlaces) {
  let replaceQuantity = value;
  if (value === '') {
    return decimalPlaces <= 0 ? '0' : `0,${getZeros(decimalPlaces)}`;
  }
  replaceQuantity = String(Number(value.replaceAll(/[^0-9]/g, '')));
  if (decimalPlaces > 0) {
    if (Number.isNaN(Number(replaceQuantity)))
      return `0,${getZeros(decimalPlaces)}`;
    if (replaceQuantity.length <= decimalPlaces) {
      return `0,${getZeros(
        decimalPlaces - replaceQuantity.length,
      )}${replaceQuantity}`;
    }
    if (
      replaceQuantity.length > decimalPlaces &&
      replaceQuantity.length < 3 + decimalPlaces
    ) {
      return `${replaceQuantity.slice(
        0,
        -decimalPlaces,
      )},${replaceQuantity.slice(-decimalPlaces)}`;
    }
    const before = replaceQuantity.slice(0, -decimalPlaces);
    const after = replaceQuantity.slice(-decimalPlaces);
    let formated = '';
    for (let i = 0; i < before.length; i++) {
      const dot = i % 3 === 0 && i !== 0 ? '.' : '';
      formated = before[before.length - 1 - i] + dot + formated;
    }
    return `${formated},${after}`;
  }
  if (Number.isNaN(Number(replaceQuantity))) return '0';
  let formated = '';
  for (let i = 0; i < replaceQuantity.length; i++) {
    const dot = i % 3 === 0 && i !== 0 ? '.' : '';
    formated = replaceQuantity[replaceQuantity.length - 1 - i] + dot + formated;
  }
  return formated;
}

function sanitize(value, decimalPlaces) {
  let v = formatNumberMask(value, decimalPlaces);
  v = v.replaceAll(/[^0-9.,]/g, '');
  v = v.replaceAll(/[.]/g, '');
  v = v.replaceAll(/,/g, '.');
  return Number(v);
}

const NumberInputBase = forwardRef(
  (
    { value, decimalPlaces = 0, prefix = '', variant = 'outlined', ...rest },
    ref,
  ) => {
    const valueFormated = `${prefix}${formatNumberMask(
      decimalPlaces <= 0
        ? String(value)
        : value.toLocaleString('de-DE', {
            minimumFractionDigits: decimalPlaces,
            maximumFractionDigits: decimalPlaces,
          }),
      decimalPlaces,
    )}`;

    return (
      <TextField
        margin="normal"
        {...rest}
        value={valueFormated}
        inputRef={ref}
        variant={variant}
      />
    );
  },
);

function NumberInput({
  name,
  group = 'default',
  priority = 1,
  visible = true,
  deps = [],
  disabled = false,
  decimalPlaces = 0,
  prefix = '',
  ...props
}) {
  return (
    <ControllerInput
      name={name}
      group={group}
      priority={priority}
      deps={deps}
      disabled={disabled}
      visible={visible}
      adapterValueOnChange={(e) => sanitize(e.target.value, decimalPlaces)}
      render={({ field }) => (
        <NumberInputBase
          {...props}
          {...field}
          decimalPlaces={decimalPlaces}
          prefix={prefix}
        />
      )}
    />
  );
}

export default NumberInput;
